import { CompanyRole } from '../enums/company-role.enum';

/** A seat of the company, as the team pickers and a unit's team name it. */
export interface TeamMemberDto {
  investorId: string;
  name: string;
  email: string;
  role: CompanyRole;
}

export interface CompanyTeamMemberDto extends TeamMemberDto {
  isYou: boolean;
  /** A member with no unit to work yet: none they manage or collaborate on, none in a portfolio they own */
  nothingToWork: boolean;
}

/** A portfolio named on an invite, as it stands now; deleted ones drop out. */
export interface InvitePortfolioDto {
  id: string;
  name: string;
  unitCount: number;
}

/** An emailed offer of a seat that nobody has accepted yet. */
export interface PendingInviteDto {
  id: string;
  email: string;
  role: CompanyRole;
  invitedByName: string;
  createdAt: string;
  expiresAt: string;
  /** Past its expiry; resending mints a fresh link */
  expired: boolean;
  /** A seat this company removed, coming back */
  rejoining: boolean;
  /** Portfolios they join as a collaborator when they accept */
  collaboratePortfolios: InvitePortfolioDto[];
}

export interface CompanyTeamDto {
  members: CompanyTeamMemberDto[];
  /** Admins only; empty for everyone else */
  pendingInvites: PendingInviteDto[];
}

export interface InviteMemberDto {
  email: string;
  role: CompanyRole;
  /** Portfolios they join as a collaborator when they accept */
  collaboratePortfolioIds?: string[];
}

export interface RemoveMemberDto {
  /** The seat that takes over every unit the leaver manages and every portfolio they own */
  transferTo: string;
}

/** Codes the team routes answer with; a client reacts to these, never to the text */
export const alreadyMemberErrorCode = 'ALREADY_MEMBER';
export const alreadyInvitedErrorCode = 'ALREADY_INVITED';
export const emailTakenErrorCode = 'EMAIL_TAKEN';
export const roleRequiredErrorCode = 'ROLE_REQUIRED';
